import { makeStyles } from 'tss-react/mui';

const useStylesTooltip: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tooltip: {
    fontSize: 14,
    border: `1px solid ${theme.palette.info.main}`,
    cursor: 'pointer',
    color: theme.palette.common.white,
    '& > span > p': {
      margin: '5px 0',
      '& > a': {
        color: theme.palette.secondary.main,
        textDecoration: 'none !important',
      },
    },
  },
  tooltipInvisible: {
    display: 'none',
  },
  tooltipPopper: {
    maxWidth: 300,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 180,
    },
  },
}));

export default useStylesTooltip;
